import { mapActions, mapGetters } from 'vuex';
import { formatAttributionPolicy } from '../constants/attributionPolicy';

export default {
  data() {
    return {};
  },
  methods: {
    ...mapActions('Report', [
      'ActionSetReportsTotal',
      'ActionSetReports',
      'ActionSetReportSelect',
      'ActionSetFilterReports',
      'ActionSetDialogReports'
    ]),

    async getClickReport(page, perPage) {
      let query = '';
      console.log(this.filterReports);

      if (!perPage) query += 'per_page=10%26';
      else query += perPage;

      if (!page) query += 'page=1';
      else query += page;

      if (!this.filterReports) query += '';
      else query += `%26${this.filterReports}`;
      this.onLoading(true);
      try {
        const { data, status } = await this.$http.get(
          '/redirect?app=report&path=/api/get/report/click_report?' + query
        );
        if (status === 200) {
          if (data.data.length > 0) {
            this.ActionSetReports(data.data);
          } else {
            this.ActionSetReports(Object.values(data.data));
          }
        } else this.ActionSetReports([]);
        this.ActionSetPagination(data);
      } catch (error) {
        if (error.response && error.response.status === 500)
          this.errorNotify(this.$t('problem_try_again_later'));
        else this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    },

    async getConsolidatedClickReport(page, perPage) {
      let query = '';

      if (!perPage) query += 'per_page=10%26';
      else query += perPage;

      if (!page) query += 'page=1';
      else query += page;

      if (!this.filterReports) query += '';
      else query += `%26${this.filterReports}`;
      this.onLoading(true);
      try {
        const { data, status } = await this.$http.get('/redirect?app=report&path=/api/report/click_report?' + query);
        if (status === 200) {
          if (data.data.length > 0) {
            this.ActionSetReports(data.data);
          } else {
            this.ActionSetReports(Object.values(data.data));
          }
          this.ActionSetPagination(data);
        } else {
          this.ActionSetReports([]);
          this.ActionSetPagination({ total: 0, data: [] });
        }
      } catch (error) {
        this.ActionSetReports([]);
        this.ActionSetPagination({ total: 0, data: [] });
        if (error.response && error.response.status === 500)
          this.errorNotify(this.$t('problem_try_again_later'));
        else this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    },

    async getClickReportAffiliate(page, perPage) {
      let query;

      if (!this.filterReports) query = '';
      else query = `${this.filterReports}%26`;

      if (!page) query += 'page=1';
      else query += page;
      if (!perPage) query += '%26per_page=10';
      else query += perPage;

      this.onLoading(true);
      try {
        const { data, status } = await this.$http.get(
          `/redirect?app=REPORT&path=/api/get/report/affiliate_click_report?${query}`
        );
        // if (data && data.data.length > 0 && status === 200) this.ActionSetReports(data.data);
        // else this.ActionSetReports();

        if (data.data && status === 200) {
          if (data.data.length > 0) {
            this.ActionSetReports(data.data);
            this.ActionSetReportsTotal(data.report_total);
          } else {
            this.ActionSetReports(Object.values(data.data));
          }
        } else this.ActionSetReports(data);
        this.ActionSetPagination(data);
      } catch (error) {
        if (error.response && error.response.status === 500)
          this.errorNotify(this.$t('problem_try_again_later'));
        else this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    },

    async getConsolidatedClickReportAffiliate(page, perPage) {
      let query;

      if (!this.filterReports) query = '';
      else query = `${this.filterReports}%26`;

      if (!page) query += 'page=1';
      else query += page;
      if (!perPage) query += '%26per_page=10';
      else query += perPage;

      this.onLoading(true);
      try {
        const { data, status } = await this.$http.get(
          `/redirect?app=REPORT&path=/api/report/affiliate_click_report/?${query}`
        );

        if (data.data && status === 200) {
          if (data.data.length > 0) {
            this.ActionSetReports(data.data);
            this.ActionSetReportsTotal(data.report_total);
          } else {
            this.ActionSetReports(Object.values(data.data));
          }
        } else this.ActionSetReports(data);
        this.ActionSetPagination(data);
      } catch (error) {
        if (error.response && error.response.status === 500)
          this.errorNotify(this.$t('problem_try_again_later'));
        else this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    },

    async getClickReportAdvertiser(page, perPage) {
      let query;

      if (!this.filterReports) query = '';
      else query = `${this.filterReports}`;

      if (!page) query += '%26page=1';
      else query += page;
      if (!perPage) query += '%26per_page=10';
      else query += perPage;

      this.onLoading(true);
      try {
        const { data, status } = await this.$http.get(
          `/redirect?app=REPORT&path=/api/old/report/advertiser_click_report?${query}`
        );
        if (status === 200) {
          this.ActionSetReports(data.data);
          this.ActionSetPagination(data);
        }
      } catch (error) {
        if (error.response && error.response.status === 500)
          this.errorNotify(this.$t('problem_try_again_later'));
        else this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    },

    async getConsolidatedClickReportAdvertiser(page, perPage) {
      let query;

      if (!this.filterReports) query = '';
      else query = `${this.filterReports}`;

      if (!page) query += '%26page=1';
      else query += page;
      if (!perPage) query += '%26per_page=10';
      else query += perPage;

      this.onLoading(true);
      try {
        const { data, status } = await this.$http.get(
          `/redirect?app=REPORT&path=/api/report/advertiser_click_report?${query}`
        );
        if (status === 200) {
          this.ActionSetReports(data.data);
          this.ActionSetPagination(data);
        }
      } catch (error) {
        if (error.response && error.response.status === 500)
          this.errorNotify(this.$t('problem_try_again_later'));
        else this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    },

    captureReportQuery() {
      const query = this.filterReports ? `${this.filterReports}` : '';
      const hasDate = /(^|%26)(start_date|end_date)=/.test(query);
      const hasDirectId = /(^|%26)(order_id|action_id|click_id)=/.test(query);

      if (hasDate || hasDirectId) {
        return query;
      }

      const today = this.$moment().format('YYYY-MM-DD');
      return `${query}${query ? '%26' : ''}start_date=${today}`;
    },

    async getCaptureReport(page, perPage) {
      let query = this.captureReportQuery();

      if (!page) query += '%26page=1';
      else query += page;
      if (!perPage) query += '%26per_page=10';
      else query += perPage;

      this.onLoading(true);
      try {
        const { data, status } = await this.$http.get('/redirect?app=REPORT&path=/api/report/captacao_report?' + query);
        if (status === 200 && data.data[0] !== false) this.ActionSetReports(data.data);
        else this.ActionSetReports();
        this.ActionSetPagination(data);
        if (data && data.enrichment_failed) this.errorNotify(this.$t('capture_enrichment_failed'));
      } catch (error) {
        if (error.response && (error.response.status === 500 || error.response.status === 503)) {
          const msg =
            error.response.data && error.response.data.message
              ? error.response.data.message
              : this.$t('problem_try_again_later');
          this.errorNotify(msg);
          if (error.response.status === 503) {
            this.ActionSetReports([]);
            this.ActionSetPagination(error.response.data || {});
          }
        } else this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    },

    async getAllCaptureReport() {
      let query = this.captureReportQuery();

      query += '%26page=1';
      query += '%26per_page=9999999999';

      this.onLoading(true);
      try {
        const { data, status } = await this.$http.get('/redirect?app=REPORT&path=/api/report/captacao_report?' + query);
        if (status === 200 && data.data[0] !== false) {
          if (data.enrichment_failed) this.errorNotify(this.$t('capture_enrichment_failed'));
          return data.data;
        }
        return [];
      } catch (error) {
        if (error.response && (error.response.status === 500 || error.response.status === 503))
          this.errorNotify(
            (error.response.data && error.response.data.message) || this.$t('problem_try_again_later')
          );
        else this.errorNotify(error);
        return [];
      } finally {
        this.onLoading(false);
      }
    },

    labelStatusCapture(status) {
      switch (status) {
        case '0':
          return this.$t('created');
        case '1':
          return this.$t('approved');
        case '2':
          return this.$t('denied');
        case '3':
          return this.$t('denied_incomplete_data');
        case '4':
          return this.$t('denied_preparation_error');
        case '5':
          return this.$t('denied_excess_characters');
        case '6':
          return this.$t('denied_invalid_values');
        case '7':
          return this.$t('denied_duplicate_transaction');
        case '8':
          return this.$t('denied_save_failure');
        case '9':
          return this.$t('denied_duplicate_transaction_exclusive');
        case '10':
          return this.$t('denied_campaign_not_found');
        case '11':
          return this.$t('denied_price_cleanup_error');
        case '12':
          return this.$t('denied_price_conversion_error');
        case '13':
          return this.$t('denied_creative_id_cleanup_error');
        case '14':
          return this.$t('denied_transaction_build_failure');
        case '15':
          return this.$t('denied_raw_transactions_save_failure');
        case '16':
          return this.$t('denied_awaiting_possible_click');
        case '17':
          return this.$t('blocked_channel_removed');
        case '18':
          return this.$t('denied_cookie_time_expired');
        case '19':
          return this.$t('cap_reached');
        case '20':
          return this.$t('denied_click_too_old');
        case '21':
          return this.$t('denied_click_campaign_mismatch');
        case '23':
          return this.$t('sent_to_raw_transactions');
        case '24':
          return this.$t('received_in_raw_transactions');
        default:
          return '';
      }
    },

    captureStatusColor(status, row) {
      if (row && row.isBadTransaction) return 'negative';
      if (row && row.campaign_mismatch) return 'orange';
      const code = String(status);
      if (['1'].includes(code)) return 'positive';
      if (['0', '23', '24'].includes(code)) return 'info';
      if (['16'].includes(code)) return 'warning';
      if (['17', '19'].includes(code)) return 'orange';
      if (['2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '18', '20', '21'].includes(code)) {
        return 'negative';
      }
      return 'grey';
    },

    formatCaptureAge(dateCreated) {
      if (!dateCreated) return this.$t('not_available');
      const created = this.$moment(dateCreated, ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DDTHH:mm:ss', this.$moment.ISO_8601], true);
      if (!created.isValid()) return this.$t('not_available');
      const minutes = this.$moment().diff(created, 'minutes');
      if (minutes < 60) return `${Math.max(0, minutes)}m`;
      const hours = this.$moment().diff(created, 'hours');
      if (hours < 48) return `${hours}h`;
      return `${this.$moment().diff(created, 'days')}d`;
    },

    formatCaptureRetries(row) {
      if (!row || row.retry === null || row.retry === undefined) return this.$t('not_available');
      const remaining = row.retries_remaining;
      if (remaining === null || remaining === undefined) return String(row.retry);
      return `${row.retry} (${remaining} ${this.$t('retries_remaining_short')})`;
    },

    formatCaptureNamedId(name, id) {
      if (name && id) return `${name} (ID:${id})`;
      if (name) return name;
      if (id) return `ID:${id}`;
      return this.$t('not_available');
    },


    async getConversionReport(page, perPage) {
      let query;
      if (!this.filterReports) query = '';
      else query = `${this.filterReports}%26`;
      if (!page) query += 'page=1';
      else query += page;
      if (!perPage) query += `%26per_page=${localStorage.getItem('rowsPerPage') || '%26per_page=10'}`;
      else query += perPage;

      this.onLoading(true);
      try {
        const { data, status } = await this.$http.get(
          `/redirect?app=REPORT&path=/api/get/report/transaction_report?user_id=${this.user.user_id}%26${query}`
        );
        if (data && data.data.length > 0 && status === 200) {
          this.ActionSetReports(data.data);
          this.ActionSetReportsTotal(data.report_total);
        } else this.ActionSetReports([]);
        this.ActionSetPagination(data);
      } catch (error) {
        if (error.response && error.response.status === 500)
          this.errorNotify(this.$t('problem_try_again_later'));
        else this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    },

    async getConversionReportAffiliate(page, perPage) {
      let query;

      if (!this.filterReports) query = '';
      else query = `${this.filterReports}%26`;

      if (!page) query += 'page=1';
      else query += page;
      if (!perPage) query += '%26per_page=10';
      else query += perPage;

      console.log(query);

      this.onLoading(true);
      try {
        const { data, status } = await this.$http.get(
          '/redirect?app=REPORT&path=/api/get/report/affiliate_transaction_report?' + query
        );
        if (data && data.data.length > 0 && status === 200) {
          this.ActionSetReports(data.data);
          this.ActionSetReportsTotal(data.report_total);
        } else this.ActionSetReports([]);
        this.ActionSetPagination(data);
      } catch (error) {
        if (error.response && error.response.status === 500)
          this.errorNotify(this.$t('problem_try_again_later'));
        else this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    },

    async getConversionReportAdvertiser(page, perPage) {
      let query;

      if (!this.filterReports) query = '';
      else query = `${this.filterReports}`;

      if (!page) query += '%26page=1';
      else query += page;
      if (!perPage) query += '%26per_page=10';
      else query += perPage;

      this.onLoading(true);
      try {
        const { data, status } = await this.$http.get(
          '/redirect?app=REPORT&path=/api/old/report/advertiser_transaction_report?' + query
        );
        if (data && data.data.length > 0 && status === 200) this.ActionSetReports(data.data);
        else this.ActionSetReports([]);
        this.ActionSetPagination(data);
      } catch (error) {
        if (error.response && error.response.status === 500)
          this.errorNotify(this.$t('problem_try_again_later'));
        else this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    },

    async getCreativeReport(page, perPage) {
      let query;

      if (!this.filterReports) query = '';
      else query = `${this.filterReports}`;

      if (!page) query += '%26page=1';
      else query += page;
      if (!perPage) query += '%26per_page=10';
      else query += perPage;

      this.onLoading(true);
      try {
        const { data, status } = await this.$http.get('/redirect?app=REPORT&path=/api/report/creative_report?' + query);

        if (data && status === 200) this.ActionSetReports(data.data);
        else this.ActionSetReports([]);
        this.ActionSetPagination(data);
      } catch (error) {
        if (error.response && error.response.status === 500)
          this.errorNotify(this.$t('problem_try_again_later'));
        else this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    },

    async getAllCreativeReport() {
      let query;

      if (!this.filterReports) query = '';
      else query = `${this.filterReports}`;

      query += '%26page=1';
      query += '%26per_page=9999999999';

      this.onLoading(true);
      try {
        const { data, status } = await this.$http.get('/redirect?app=REPORT&path=/api/report/creative_report?' + query);

        if (data && status === 200) return data.data;
      } catch (error) {
        if (error.response && error.response.status === 500)
          this.errorNotify(this.$t('problem_try_again_later'));
        else this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    },

    async getCreativeReportAdvertiser(page, perPage) {
      let query;

      if (!this.filterReports) query = '';
      else query = `${this.filterReports}`;

      if (!page) query += '%26page=1';
      else query += page;
      if (!perPage) query += '%26per_page=10';
      else query += perPage;

      this.onLoading(true);
      try {
        const { data, status } = await this.$http.get(
          '/redirect?app=REPORT&path=/api/report/creative_report_advertiser?' + query
        );

        if (data && status === 200) this.ActionSetReports(data.data);
        else this.ActionSetReports([]);
        this.ActionSetPagination(data);
      } catch (error) {
        if (error.response && error.response.status === 500)
          this.errorNotify(this.$t('problem_try_again_later'));
        else this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    },

    async createExtraMargin(campaignId, value, userEmail, emailSent) {
      this.onLoading(true);
      try {
        return await this.$http.post('/v2/redirect?app=REPORT&path=/api/transaction/history/create_extra_margin', {
          params: {
            data: {
              campaign_id: campaignId,
              value: value,
              user_email: userEmail,
              email_sent_at: emailSent
            }
          }
        });
      } catch (error) {
        if (error.response && error.response.status === 500)
          this.errorNotify(this.$t('problem_try_again_later'));
        else this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    },

    async getLatestEmailSent(campaignId) {
      this.onLoading(true);
      try {
        const { data, status } = await this.$http.get(
          '/redirect?app=REPORT&path=/api/transaction/history/emails-sent/' + campaignId
        );

        if (data && status === 200) {
          return data;
        }
      } catch (error) {
        if (error.response && error.response.status === 500)
          this.errorNotify(this.$t('problem_try_again_later'));
        else this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    }
  },
  computed: {
    ...mapGetters('Report', ['reportsTotal', 'reports', 'reportSelect', 'filterReports', 'dialogReports']),

    columns() {
      return [
        {
          name: 'id_creative',
          label: 'ID',
          align: 'left',
          field: 'id_creative',
          sortable: true
        },
        {
          name: 'creative_type',
          label: this.$t('creative_type'),
          align: 'left',
          field: 'creative_type',
          sortable: true
        },
        {
          name: 'resolution',
          label: this.$t('image_banner_size'),
          align: 'left',
          field: 'resolution',
          sortable: true
        },
        {
          name: 'prints',
          label: this.$t('amount_of_prints'),
          align: 'left',
          field: 'prints',
          sortable: true
        },
        {
          name: 'clicks',
          label: this.$t('amount_of_clicks'),
          align: 'left',
          field: 'clicks',
          sortable: true
        },
        {
          name: 'uniqueClicks',
          label: this.$t('amount_unique_clicks'),
          align: 'left',
          field: 'uniqueClicks',
          sortable: true
        },
        {
          name: 'transactions',
          label: this.$t('amount_of_conversions'),
          align: 'left',
          field: 'transactions',
          sortable: true
        },
        {
          name: 'pending_total_amount',
          label: this.$t('full_commission_amount_pending'),
          align: 'left',
          field: 'pending_total_amount',
          sortable: true
        },
        {
          name: 'pending_margin',
          label: this.$t('afilio_commission_amount_pending'),
          align: 'left',
          field: 'pending_margin',
          sortable: true
        },
        {
          name: 'pending_cost',
          label: this.$t('affiliate_commission_amount_pending'),
          align: 'left',
          field: 'pending_cost',
          sortable: true
        },
        {
          name: 'approved_total_amount',
          label: this.$t('full_commission_amount_approved'),
          align: 'left',
          field: 'approved_total_amount',
          sortable: true
        },
        {
          name: 'approved_margin',
          label: this.$t('amount_afilio_commission_approved'),
          align: 'left',
          field: 'approved_margin',
          sortable: true
        },
        {
          name: 'approved_cost',
          label: this.$t('amount_affiliate_commission_approved'),
          align: 'left',
          field: 'approved_cost',
          sortable: true
        }
      ];
    },

    conversionColumns() {
      return [
        {
          name: 'campaign_id',
          label: this.$t('campaign_id'),
          align: 'left',
          field: 'campaign_id',
          sortable: true
        },
        {
          name: 'campaign_name',
          label: this.$t('campaign_name'),
          align: 'left',
          field: 'campaign_name',
          sortable: true
        },
        {
          name: 'advertiser_id',
          label: 'ID Advertiser',
          align: 'left',
          field: 'advertiser_id',
          sortable: true
        },
        {
          name: 'site_id',
          label: this.$t('channel_id'),
          align: 'left',
          field: 'site_id',
          sortable: true
        },
        {
          name: 'site_name',
          label: this.$t('channel_name'),
          align: 'left',
          field: 'site_name',
          sortable: true
        },
        {
          name: 'affiliate_id',
          label: this.$t('affiliate_id'),
          align: 'left',
          field: 'affiliate_id',
          sortable: true
        },
        {
          name: 'affiliate_name',
          label: this.$t('affiliate_name'),
          align: 'left',
          field: 'affiliate_name',
          sortable: true
        },
        {
          name: 'transaction_id',
          label: this.$t('transaction_id'),
          align: 'left',
          field: 'transaction_id',
          sortable: true
        },
        {
          name: 'bonus_id',
          label: this.$t('bonus_id'),
          align: 'left',
          field: 'bonus_id',
          sortable: true
        },
        {
          name: 'order_id',
          label: 'Tra ID',
          align: 'left',
          field: 'order_id',
          sortable: true
        },
        {
          name: 'creative_id',
          label: this.$t('creative_id'),
          align: 'left',
          field: 'creative_id',
          sortable: true
        },
        {
          name: 'creative_type',
          label: this.$t('creative_type'),
          align: 'left',
          field: 'creative_type',
          sortable: true
        },
        {
          name: 'cj_customer_status',
          label: this.$t('cj_customer_status'),
          align: 'left',
          field: 'cust_status'
        },
        {
          name: 'click_id',
          label: 'Click ID',
          align: 'left',
          field: 'click_id'
        },
        {
          name: 'coupon_code',
          label: this.$t('coupon_code_used'),
          align: 'left',
          field: 'coupon_code',
          sortable: true
        },
        {
          name: 'attribution_policy',
          label: this.$t('attribution_rule'),
          align: 'left',
          field: 'attribution_policy',
          sortable: true,
          format: (val) => formatAttributionPolicy(this, val)
        },
        {
          name: 'comission_id',
          label: 'Act_ID',
          align: 'left',
          field: 'comission_id',
          sortable: true
        },
        {
          name: 'comission_type',
          label: this.$t('type'),
          align: 'left',
          field: 'comission_type',
          sortable: true
        },
        {
          name: 'comission_category',
          label: this.$t('commission_category'),
          align: 'left',
          field: 'comission_category',
          sortable: true
        },
        {
          name: 'comission_rule_name',
          label: this.$t('commission_rule'),
          align: 'left',
          field: 'comission_rule_name',
          sortable: true
        },
        {
          name: 'transaction_amount',
          label: this.$t('transaction_amount'),
          align: 'left',
          field: 'transaction_amount',
          sortable: true
        },
        {
          name: 'full_commission_amount',
          label: this.$t('full_commision_amount'),
          align: 'left',
          field: 'full_commission_amount',
          sortable: true
        },
        {
          name: 'affiliate_commission_cost',
          label: this.$t('affiliate_commission_cost'),
          align: 'left',
          field: 'affiliate_commission_cost',
          sortable: true
        },
        {
          name: 'afilio_commition_margin',
          label: this.$t('margin_afilio_commission'),
          align: 'left',
          field: 'afilio_commition_margin',
          sortable: true
        },
        {
          name: 'xtrasParams1',
          label: this.$t('affiliate_parameter') + ' Xtra1',
          align: 'left',
          field: 'xtrasParams1',
          sortable: true
        },
        {
          name: 'xtrasParams2',
          label: this.$t('affiliate_parameter') + ' Xtra2',
          align: 'left',
          field: 'xtrasParams2',
          sortable: true
        },
        {
          name: 'xtrasParams3',
          label: this.$t('affiliate_parameter') + ' Xtra3',
          align: 'left',
          field: 'xtrasParams3',
          sortable: true
        },
        {
          name: 'xtrasParams4',
          label: this.$t('affiliate_parameter') + ' Xtra4',
          align: 'left',
          field: 'xtrasParams4',
          sortable: true
        },
        {
          name: 'xtrasParams5',
          label: this.$t('affiliate_parameter') + ' Xtra5',
          align: 'left',
          field: 'xtrasParams5',
          sortable: true
        },
        {
          name: 'ad_xtra1',
          label: this.$t('advertiser_parameter') + ' Xtra1',
          align: 'left',
          field: 'ad_xtra1',
          sortable: true
        },
        {
          name: 'ad_xtra2',
          label: this.$t('advertiser_parameter') + ' Xtra2',
          align: 'left',
          field: 'ad_xtra2',
          sortable: true
        },
        {
          name: 'ad_xtra3',
          label: this.$t('advertiser_parameter') + ' Xtra3',
          align: 'left',
          field: 'ad_xtra3',
          sortable: true
        },
        {
          name: 'ad_xtra4',
          label: this.$t('advertiser_parameter') + ' Xtra4',
          align: 'left',
          field: 'ad_xtra4',
          sortable: true
        },
        {
          name: 'ad_xtra5',
          label: this.$t('advertiser_parameter') + ' Xtra5',
          align: 'left',
          field: 'ad_xtra5',
          sortable: true
        },
        {
          name: 'click_datetime',
          label: this.$t('click_datetime'),
          align: 'left',
          field: 'click_datetime',
          sortable: true,
          format: (val) => this.formatToPt(val)
        },
        {
          name: 'transaction_datetime',
          label: this.$t('transaction_datetime'),
          align: 'left',
          field: 'transaction_datetime',
          sortable: true,
          format: (val) => this.formatToPt(val)
        },
        {
          name: 'validation_datetime',
          label: this.$t('validation_datetime'),
          align: 'left',
          field: 'validation_datetime',
          sortable: true,
          format: (val) => this.formatToPt(val)
        },
        {
          name: 'payment_date',
          label: this.$t('payment_date'),
          align: 'left',
          field: 'payment_date',
          sortable: true,
          format: (val) => this.formatToPt(val)
        },
        {
          name: 'time_diff',
          label: 'Date Dif',
          align: 'left',
          field: 'time_diff',
          sortable: true
        },
        {
          name: 'ip',
          label: 'IP',
          align: 'left',
          field: 'ip',
          sortable: true
        },
        {
          name: 'validation_status',
          label: 'Status',
          align: 'left',
          field: 'status_name',
          sortable: true
          // format: (status) => this.labelStatus(status),
        },
        {
          name: 'cj_transactions_id',
          label: 'Transaction ID CJ',
          align: 'left',
          field: 'cj_transactions_id',
          sortable: true
        },
        {
          name: 'bookingDate',
          label: this.$t('booking_date'),
          align: 'left',
          field: 'bookingDate',
          sortable: true
        },
        {
          name: 'bookingStatus',
          label: this.$t('booking_status'),
          align: 'left',
          field: 'bookingStatus',
          sortable: true
        },
        {
          name: 'couponType',
          label: this.$t('coupon_type'),
          align: 'left',
          field: 'couponType',
          sortable: true
        },
        {
          name: 'couponDiscount',
          label: this.$t('coupon_discount'),
          align: 'left',
          field: 'couponDiscount',
          sortable: true
        },
        {
          name: 'destCity',
          label: this.$t('destination_city'),
          align: 'left',
          field: 'destCity',
          sortable: true
        },
        {
          name: 'destCountry',
          label: this.$t('destination_country'),
          align: 'left',
          field: 'destCountry',
          sortable: true
        },
        {
          name: 'endDateTime',
          label: this.$t('end_date_time'),
          align: 'left',
          field: 'endDateTime',
          sortable: true,
          format: (val) => this.formatToPt(val)
        },
        {
          name: 'platformId',
          label: this.$t('platform_id'),
          align: 'left',
          field: 'platformId',
          sortable: true
        },
        {
          name: 'source_url',
          label: 'URL Resp',
          align: 'left',
          field: 'source_url',
          sortable: true
        },
        {
          name: 'first_url',
          label: this.$t('redirect_url'),
          align: 'left',
          field: 'first_url',
          sortable: true
        }
      ];
    },

    captureColumns() {
      return [
        {
          name: 'orderId',
          required: true,
          label: 'Order ID',
          align: 'left',
          field: 'orderId',
          sortable: true
        },
        {
          name: 'actionId',
          required: true,
          label: 'Action ID',
          align: 'left',
          field: 'actionId',
          sortable: true
        },
        {
          name: 'campaign_name',
          required: true,
          label: this.$t('campaign_name'),
          align: 'left',
          field: 'campaign_name',
          sortable: true,
          format: (value, row) => this.formatCaptureNamedId(value, row && row.campaign_id)
        },
        {
          name: 'click_campaign_name',
          required: true,
          label: this.$t('click_campaign_name'),
          align: 'left',
          field: 'click_campaign_name',
          sortable: true,
          format: (value, row) => this.formatCaptureNamedId(value, row && row.click_campaign_id)
        },
        {
          name: 'site_name',
          required: true,
          label: this.$t('channel_name'),
          align: 'left',
          field: 'site_name',
          sortable: true,
          format: (value, row) => this.formatCaptureNamedId(value, row && row.site_id)
        },
        {
          name: 'campaign_mismatch',
          required: true,
          label: this.$t('campaign_mismatch'),
          align: 'left',
          field: 'campaign_mismatch',
          sortable: true,
          format: (value) => (value ? this.$t('yes') : this.$t('no'))
        },
        {
          name: 'status',
          required: true,
          label: 'Status',
          align: 'left',
          field: 'status',
          sortable: true,
          format: (status, row) =>
            row && row.isBadTransaction ? this.$t('denied_missing_click_id') : this.labelStatusCapture(status)
        },
        {
          name: 'age',
          required: true,
          label: this.$t('capture_age'),
          align: 'left',
          field: 'dateCreated',
          sortable: true,
          format: (value) => this.formatCaptureAge(value)
        },
        {
          name: 'retry',
          required: true,
          label: this.$t('capture_retries'),
          align: 'left',
          field: 'retry',
          sortable: true,
          format: (_value, row) => this.formatCaptureRetries(row)
        },
        {
          name: 'clickId',
          required: true,
          label: 'Click ID',
          align: 'left',
          field: 'clickId',
          sortable: true
        },
        {
          name: 'couponCode',
          required: true,
          label: this.$t('coupon'),
          align: 'left',
          field: 'couponCode',
          sortable: true
        },
        {
          name: 'cookieId',
          required: true,
          label: 'Cookie ID',
          align: 'left',
          field: 'cookieId',
          sortable: true
        },
        {
          name: 'dateCreated',
          required: true,
          label: this.$t('created_at'),
          align: 'left',
          field: 'dateCreated',
          sortable: true
        },
        {
          name: 'objId',
          required: true,
          label: 'OBJ ID',
          align: 'left',
          field: 'objId',
          sortable: true
        },
        {
          name: 'price',
          required: true,
          label: this.$t('price'),
          align: 'left',
          field: 'price',
          sortable: true
        }
      ];
    }
  }
};
